/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import * as React from "react";
import styled, { css, ThemeProps, withTheme } from "styled-components";

interface Props {
    /** used to accomplish line-clamp functionality */
    lineHeight?: number;
    /** any value < 1 is considered as no truncation */
    lines?: number;
}

const Truncated = styled.span<Props & ThemeProps<BaseTheme>>`
    overflow-wrap: break-word;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    display: -moz-box;
    display: box;

    -moz-box-orient: vertical; /* Mozilla */
    -webkit-box-orient: vertical; /* WebKit */
    box-orient: vertical;

    -moz-line-clamp: ${props => props.lines};
    -webkit-line-clamp: ${props => props.lines};
    line-clamp: ${props => props.lines};
    line-height: ${props => props.lineHeight}px;
    max-height: ${props => props.lines! * props.lineHeight!}px;
`;

const Truncate: React.FC<Props & ThemeProps<BaseTheme>> = ({ lineHeight = 20, lines = 1, ...otherProps }) => {
    return (
        <Truncated lines={lines} lineHeight={lineHeight}>
            {otherProps.children}
        </Truncated>
    );
};

export default withTheme(Truncate);
